import { Component, h, tag } from "omi";

import { Track } from "@/api";
import { tailwind } from "@/tailwind";

import globalStyles from "../../globals/styles.css?inline";
import styles from "../../app.css?inline";

type Props = Required<Track> & { ref: string };

@tag("nw-track")
export class NWTrack extends Component<Props> {
  static css = [tailwind, globalStyles, styles];

  static propTypes = {
    id: String,
    title: String,
    description: String,
    ref: String,
  };

  render() {
    return <div></div>;
  }
}
